"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.answerValues = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _useTranslated = require("../../hooks/useTranslated");
var _radioGroup = _interopRequireDefault(require("../../components/radioGroup"));
var _excluded = ["input"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @desc US Resident (standard component) answer values
 *
 * @type {{[key: string]: string}}
 */
var answerValues = exports.answerValues = {
  yes: 'yes',
  no: 'no'
};
var Resident = function Resident(_ref) {
  var input = _ref.input,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var label = (0, _useTranslated.useTranslated)('fields.usResident.questionLabel');
  var answers = [{
    label: (0, _useTranslated.useTranslated)('common.yes'),
    value: 'yes'
  }, {
    label: (0, _useTranslated.useTranslated)('common.no'),
    value: 'no'
  }];
  return /*#__PURE__*/_react["default"].createElement(_radioGroup["default"], (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, props), {}, {
    config: _objectSpread(_objectSpread({}, props.config), {}, {
      options: answers
    })
  }), {
    input: input,
    label: label
  }));
};
Resident.propTypes = {
  input: {
    name: _propTypes["default"].string.isRequired,
    onChange: _propTypes["default"].func.isRequired
  }
};
var _default = exports["default"] = Resident;